export const toQuery = (object = {}) => {
  if (!object) {
    return "";
  }

  return Object.keys(object)
    .map((key) => {
      const field = object[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(field)}`;
    })
    .join("&");
};

// this.toArrayQuery({ location: this.form.location, service: this.form.service})

export const toArrayQuery = (object = {}) => {
  if (!object) {
    return "";
  }

  let queryParamsArray = Object.keys(object).map((key) => {
    if (Array.isArray(object[key])) {
      return object[key].map((value) => `${key}[]=${value}`).join("&");
    }
  });

  let queryParams = "";
  queryParamsArray.forEach((val) => {
    if (val) {
      queryParams = queryParams + "&" + val;
    }
  });

  return queryParams;
};
